import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery} from '@apollo/react-hooks'
import {
  FeesChartByPartnerId_partnersCharts,
  FeesChartByPartnerId_partnersChartsVariables
} from '../../../_generated/FeesChartByPartnerId_partnersCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query FeesChartByPartnerId_partnersCharts($id: ID!, $precision: Precision!) {
  charts {
    byPartnerId(id: $id) {
      id: partnerId
      fees(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = FeesChartByPartnerId_partnersCharts
export type V = FeesChartByPartnerId_partnersChartsVariables
export type R = Q['charts']['byPartnerId']['fees']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byPartnerId.fees)

}

export function Use(partnerId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: partnerId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
